import { type OperationId } from "@gen/app-access-config";
import { type IAdminTransaction } from "@gen/app-query";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { AcceptF2fDepositAction } from "./actions/AcceptF2fDepositAction";
import { CancelTransactionAction } from "./actions/CancelTransactionAction";
import { ConfirmF2fHandoverAction } from "./actions/ConfirmF2fHandoverAction";
import { ReleaseFunds } from "./actions/ReleaseFunds";
import { SetTrackingDetailsAction } from "./actions/SetTrackingDetailsAction";
import { SetTrackingDetailsF2fAction } from "./actions/SetTrackingDetailsF2fAction";

interface SellerActionsSectionProps {
  canExecuteForStatus: (operationId: OperationId) => boolean;
  isF2f?: boolean;
  transactionData: IAdminTransaction;
}

export function SellerActionsSection({
  canExecuteForStatus,
  transactionData,
  isF2f,
}: SellerActionsSectionProps) {
  const transactionId = transactionData.id;
  const userTransactionRole = "seller";
  return (
    <Stack
      spacing={5}
      sx={{
        pt: 5,
      }}
    >
      <Typography variant="h6DashedDivider" gutterBottom>
        Actions
      </Typography>
      {isF2f && (
        <AcceptF2fDepositAction
          transactionId={transactionId}
          canExecuteForStatus={canExecuteForStatus}
          userTransactionRole={userTransactionRole}
          isDepositInReview={transactionData.deposit_in_review}
        />
      )}
      {isF2f && transactionData.contains_shipping !== true && (
        <ConfirmF2fHandoverAction
          transactionId={transactionId}
          canExecuteForStatus={canExecuteForStatus}
          userTransactionRole={userTransactionRole}
        />
      )}
      <ReleaseFunds
        userTransactionRole={userTransactionRole}
        canExecuteForStatus={canExecuteForStatus}
        transactionId={transactionId}
        isF2f={isF2f}
      />
      <CancelTransactionAction
        canExecuteForStatus={canExecuteForStatus}
        userTransactionRole={userTransactionRole}
        transactionId={transactionId}
        isF2f={isF2f}
      />
      {isF2f && transactionData.contains_shipping !== false && (
        <SetTrackingDetailsF2fAction
          transactionId={transactionId}
          canExecuteForStatus={canExecuteForStatus}
          tracking={transactionData.tracking}
        />
      )}
      {!isF2f && (
        <SetTrackingDetailsAction
          transactionId={transactionId}
          canExecuteForStatus={canExecuteForStatus}
          tracking={transactionData.tracking}
        />
      )}
    </Stack>
  );
}
